import React, { useCallback, useEffect } from 'react'
import {
  StyledContinueButtonContainer,
  StyledObjectData,
  StyledObjectType,
} from './IndexObjectDataForm.styled'
import RadioGroupButtons from 'components/RadioGroupButtons/RadioGroupButtons'
import { useAppDispatch } from 'store/hooks'
import { useSelector } from 'react-redux'
import { selectAddressFormData, setFormField } from 'slices/addressFormSlice'
import { useTranslation } from 'react-i18next'
import { ObjectType } from 'types/ApiResponse'
import { getObjectTypeOptions } from '../../ObjectTypeOptions/ObjectTypeOptions'
import { includeContactDetailsSelect } from '../../helper'
import Button from 'components/Button/Button'

const reportTypeSelect = [
  {
    key: 'VALUATION',
    value: 'newAddressModal.objectDataTab.reportType.valuation',
    disabled: false,
  },
  { key: 'RENT', value: 'newAddressModal.objectDataTab.reportType.rent', disabled: false },
]

export const periodTypeSelect = [
  {
    key: 'YEAR_1',
    value: 'newAddressModal.objectDataTab.periodType.1_year',
    disabled: false,
  },
  {
    key: 'YEAR_2',
    value: 'newAddressModal.objectDataTab.periodType.2_year',
    disabled: false,
  },
  {
    key: 'YEAR_5',
    value: 'newAddressModal.objectDataTab.periodType.5_year',
    disabled: false,
  },
  {
    key: 'YEAR_10',
    value: 'newAddressModal.objectDataTab.periodType.10_year',
    disabled: false,
  },
]

const IndexObjectDataForm = (props: any) => {
  const { setCurrentTab } = props
  const dispatch = useAppDispatch()
  const addressFormData = useSelector(selectAddressFormData)
  const { t } = useTranslation()
  const reportTypeSelectArray = [...reportTypeSelect]
  const periodTypeSelectArray = [...periodTypeSelect]
  const isDE = addressFormData.addressData?.nation === 'DE'
  const objectTypeOptions = getObjectTypeOptions(isDE, t)

  const handleChangeObjectType = useCallback(
    (value: ObjectType) => {
      dispatch(setFormField({ key: 'propertyDetails.objectType', value }))
    },
    [dispatch]
  )

  const handleChangeReportType = (value: string) => {
    dispatch(setFormField({ key: 'indexDetails.reportType', value }))
  }

  const handleChangePeriodType = (value: string) => {
    dispatch(setFormField({ key: 'indexDetails.periodType', value }))
  }

  const handleChangeIncludeContactDetails = (value: string) => {
    dispatch(setFormField({ key: 'indexDetails.includeContactDetails', value }))
  }

  const onContinueClick = () => {
    setCurrentTab((tab) => tab + 1)
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (
      !addressFormData.addressData?.indexDetails?.reportType &&
      !addressFormData.addressData?.indexDetails?.includeContactDetails
    ) {
      dispatch(setFormField({ key: 'indexDetails.reportType', value: 'VALUATION' }))
      dispatch(setFormField({ key: 'indexDetails.includeContactDetails', value: false }))
    }
    if (!addressFormData.addressData?.indexDetails?.periodType) {
      dispatch(setFormField({ key: 'indexDetails.periodType', value: 'YEAR_1' }))
    }
  }, [
    dispatch,
    addressFormData.addressData?.indexDetails?.reportType,
    addressFormData.addressData?.indexDetails?.periodType,
    addressFormData.addressData?.indexDetails?.includeContactDetails,
  ])
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    if (!addressFormData.addressData?.propertyDetails?.objectType) {
      handleChangeObjectType(ObjectType.HOUSE)
    }
  }, [addressFormData.addressData, handleChangeObjectType])

  return (
    <>
      <StyledObjectData>
        <StyledObjectType>
          <RadioGroupButtons
            options={objectTypeOptions}
            label={`${t('newAddressModal.objectDataTab.objectType')}*`}
            onChangeProps={handleChangeObjectType}
            value={addressFormData.addressData?.propertyDetails?.objectType}
          />
        </StyledObjectType>
        <StyledObjectType>
          <RadioGroupButtons
            options={reportTypeSelectArray}
            label={`${t('newAddressModal.objectDataTab.reportType')}*`}
            onChangeProps={handleChangeReportType}
            value={addressFormData.addressData?.indexDetails?.reportType}
          />
        </StyledObjectType>
        <StyledObjectType>
          <RadioGroupButtons
            options={periodTypeSelectArray}
            label={`${t('newAddressModal.objectDataTab.periodType')}*`}
            onChangeProps={handleChangePeriodType}
            value={addressFormData.addressData?.indexDetails?.periodType}
          />
        </StyledObjectType>
        <StyledObjectType>
          <RadioGroupButtons
            options={includeContactDetailsSelect}
            label={`${t('newAddressModal.objectDataTab.includeContactDetails')}*`}
            onChangeProps={handleChangeIncludeContactDetails}
            value={addressFormData.addressData?.indexDetails?.includeContactDetails}
          />
        </StyledObjectType>
      </StyledObjectData>
      <StyledContinueButtonContainer>
        <Button kind="primary" onClick={() => onContinueClick()}>
          {t('common.continueButton')}
        </Button>
      </StyledContinueButtonContainer>
    </>
  )
}

export default IndexObjectDataForm
